import { render } from "./OdsLogo.vue?vue&type=template&id=7faf67c4"
import script from "./OdsLogo.vue?vue&type=script&lang=js"
export * from "./OdsLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__